import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import Platform from './components/Platform';
import Introduction from './components/Introduction';
import Authentication from './components/Authentication';
import CountrySwiper from './components/CountrySwiper';
import CountryTitle from './components/CountrySwiper/CountryTitle';
import MessageSwiper from './components/MessageSwiper';
import Dashboard from './components/Dashboard';
import LogoSliders from './components/LogoSliders';
import { GetStarted, Features, Hero } from './components';

const IndexView = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  return (
    <Box sx={{ overflowX: 'hidden', overflowY: 'auto' }}>
      <Main
      // bgcolor={'background.paper'}
      // bgcolor={'rgba(41, 95, 255, 0.25)'}
      >
        <Hero />
        <Container
          paddingY="0 !important"
          data-aos={isMd ? 'fade-left' : 'fade-up'}
        >
          <LogoSliders />
        </Container>
        <Box
          sx={{
            backgroundImage: `linear-gradient(to bottom, ${alpha(
              theme.palette.background.paper,
              0,
            )}, ${alpha(theme.palette.alternate.main, 1)} 100%)`,
            backgroundRepeat: 'repeat-x',
            position: 'relative',
          }}
        >
          <Container paddingY={{ xs: 1, sm: 1, md: 1 }}>
            <Features />
          </Container>
        </Box>
        <Container>
          <GetStarted />
        </Container>
        <Box
          sx={{
            maxWidth: '100%',
            backgroundColor: '#FFFCF1',
          }}
        >
          <Container paddingY={{ xs: 4, sm: 6, md: 6 }}>
            <Introduction />
          </Container>
        </Box>
        <Container paddingY={{ xs: 4, sm: 4, md: 8 }}>
          <Platform />
        </Container>
        <Container
          sx={{
            maxWidth: '100%',
            bgcolor: '#fff',
          }}
        >
          <Dashboard />
        </Container>
        <Box
          sx={{
            maxWidth: '100%',
            bgcolor: '#171C61',
          }}
        >
          <Container paddingY={{ xs: 4, sm: 6, md: 6 }}>
            <Authentication />
          </Container>
        </Box>
        <Container paddingY="0 !important">
          <MessageSwiper />
        </Container>
        <Box
          sx={{
            maxWidth: '100%',
            bgcolor: '#fff',
          }}
        >
          <Container paddingY="0 !important">
            <CountryTitle />
          </Container>
          <CountrySwiper />
        </Box>
      </Main>
    </Box>
  );
};

export default IndexView;
